import { PropsWithChildren } from 'react'

export const ReportCard = ({ children }: PropsWithChildren) => (
  <section className="drop-shadow-chat-bubble flex w-full flex-col gap-6 rounded-2xl bg-white p-4" data-testid="report-card">
    {children}
  </section>
)
